var intersect = function intersect(first) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return rest.reduce(function (accum, current) {
    return accum.filter(function (x) {
      return current.indexOf(x) !== -1;
    });
  }, first);
};

export default intersect;



//////////////////
// WEBPACK FOOTER
// ./~/array-intersect/dist/array-intersect.module.js
// module id = 206
// module chunks = 64